module.exports = __webpack_public_path__ + "static/homeless-shelters.44739ba1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/homeless-shelters.jpg
// module id = 474
// module chunks = 53960106793232